import React from "react"
import { Link } from "gatsby"
import logo from "./oravro-logo2.png"

const Layout = props => {
  const { title, children } = props
  const [toggleNav, setToggleNav] = React.useState(false)
  return (
    <div className={`site-wrapper ${toggleNav ? `site-head-open` : ``}`}>
      <header className="site-head">
                   
        <div className="site-head-container">

         <Link className="site-head-logo" to={`/`}>
              <img src={logo}  className="abc" alt="Esports Gaming House for MONEY" />

            </Link>
          <a
            className="nav-burger"
            href={`#`}
            onClick={() => setToggleNav(!toggleNav)}
          >
            <div
              className="hamburger hamburger--collapse"
              aria-label="Menu"
              role="button"
              aria-controls="navigation"
            >
              <div className="hamburger-box">
                <div className="hamburger-inner" />
              </div>
            </div>
          </a>
          <nav id="swup" class="site-head-left">
            <ul className="nav" role="menu">
              <li className="nav-home nav-current" role="menuitem">
                <Link to={`/`}>Home</Link>
              </li>
              <li className="nav-about" role="menuitem">
                <Link to={`/about`}>About</Link>
              </li>
<li>{title}  </li>
            </ul>
          </nav>
          <div className="site-head-center">
 
   
          </div> 
         <div className="site-head-right">
           <p> profile available only for our team members and fans !</p>
            <div className="social-links">
              <a
                href="https://www.facebook.com"
                title="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
              <a
                href="https://twitter.com"
                title="Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                Twitter
              </a>
              <Link
                to={`/rss.xml`}
                title="RSS"
                target="_blank"
                rel="noopener noreferrer"
              >
                RSS
              </Link>
            </div>
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main">

        <div id="swup" className="transition-fade">
          {children}
        </div>
 
      </main>
      

        
        
      <footer className="site-foot">
        &copy; {new Date().getFullYear()} <Link to={`/`}>{title}</Link> &mdash;
        From 2011 {" "}
        <a
          href="https://esporttalk.org"
          target="_blank"
          rel="noopener noreferrer"
        >
        esport bet tips

        </a>

      </footer>
    </div>
  )
}

export default Layout
